module.exports = __webpack_public_path__ + "img/checkbox-off.1438b15a.svg";